export const selectDataByJobGUID = (state, { jobGUID }) => state[jobGUID] ?? undefined;

export const selectHasErrors = (state) => state.hasErrors;
